export default __webpack_public_path__ + "assets/png/1a5cadac2254d94ea5e68217cccfbd5e.png";